import { Model } from 'miragejs'

export const bucketModel = Model.extend({})
